// extracted by mini-css-extract-plugin
export default {"paymentInfo":"BookingFinishPage_paymentInfo__nPqFb","priceForAll":"BookingFinishPage_priceForAll__3--my","copyVoucher":"BookingFinishPage_copyVoucher__No-CP"};